import { render } from "./UnitDetails.vue?vue&type=template&id=b256fd4a"
import script from "./UnitDetails.vue?vue&type=script&lang=js"
export * from "./UnitDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__